import { getGroupOverridePerms, type Group } from '@seen/core/groups'
import type { StateCreator } from 'zustand'

export interface PermsState {
  isMOE: boolean
  isTech: boolean
  isIDT: boolean
  isAuditor: boolean
  groupOverride?: Group
  setGroupOverride: (group?: Group) => void
}

export const createPermsStore: StateCreator<PermsState> = (set) => ({
  ...getGroupOverridePerms(undefined),
  groupOverride: undefined,
  setGroupOverride: (group) =>
    set(() => ({
      groupOverride: group,
      ...getGroupOverridePerms(group),
    })),
})
